import { useAppSelector } from '@online-webinar/store';
import { useTranslation } from 'react-i18next';

export const ParticipantListCount = () => {
    const { t } = useTranslation();
    const onlineParticipants = useAppSelector((state) => state.liveWebinar.onlineParticipants);

    return (
        <p className="bg-accent-light rounded-lg mb-4 p-2">
            {t('Participants.Online')} {onlineParticipants}
        </p>
    );
};
